import { render, staticRenderFns } from "./ProfWidget3.vue?vue&type=template&id=317bc664&"
import script from "./ProfWidget3.vue?vue&type=script&lang=js&"
export * from "./ProfWidget3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports